import VueBaseController from './vue_base'

export class ShowController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/thank_you/show.vue')
  }

  static values = {
    token: String
  }

  connect() {
    super.connect({
      token: this.tokenValue
    })
  }
}
